import DF from '@/lib/define';
// =============================================================================
// ライブラリ
// =============================================================================
function lib () {
  // ===========================================================================
  //  関数名    : id
  //  機能      : タグエレメント取得
  //  引数      : value : タグID
  //  戻り値    : obj : タグエレメント
  // ===========================================================================
  function  $id (value) {
    return document.getElementById(value);
  }
  // ===========================================================================
  //  関数名    : pint
  //  機能      : 文字列、数値をINTにキャスト
  //  引数      : num : 文字列 or 数値(String or Number or int)
  //  戻り値    : val : 数値(int)
  // ===========================================================================
  function pint (num) {
    if (num === '' || num === null) {
      return 0;
    }
    return parseInt(num, 10);
  }
  // ===========================================================================
  //  関数名    : emptyChk
  //  機能      : '', null, undefinedをチェック
  //  引数      : value : 文字列 or 数値
  //  戻り値    : boolean : [false: 空]
  // ===========================================================================
  function emptyChk (value, option) {
    if (value === '' || value === null || value === undefined) {
      return false;
    }
    if (option === true) {
      if (value === 0) {
        return false;
      }
    }
    return true;
  }
  // ===========================================================================
  //  関数名    : zero_add
  //  機能      : 1桁Numberに「0」を付加し、Stringで返す
  //  引数      : val : 数値(Number or int)
  //  戻り値    : str : 数値(String)
  // ===========================================================================
  function zero_add (val) {
    return String((val >= 0 && val < 10) ? '0' + val : val);
  }
  // ===========================================================================
  //  関数名    : zero_del
  //  機能      : 0付2桁Stringから「0」を削除し、Numberで返す
  //  引数      : str : 数値(String)
  //  戻り値    : val : 数値(int)
  // ===========================================================================
  function zero_del (str) {
    if (str.slice(0, 1) === '0') {
      return Number(str.slice(1));
    }
    return pint(str);
  }
  // ===========================================================================
  //  関数名    : date_text_get
  //  機能      : dateｵﾌﾞｼﾞｪｸﾄから日付を8桁のStringを作成
  //  引数      : dateobj : date ｵﾌﾞｼﾞｪｸﾄ(Date)
  //  戻り値    : 日付TEXT(String)
  // ===========================================================================
  function date_text_get (dateobj) {
    return '' + dateobj.getFullYear() + zero_add(dateobj.getMonth() + 1) + zero_add(dateobj.getDate());
  }
  // ===========================================================================
  //  関数名    : date_array_get
  //  機能      : dateｵﾌﾞｼﾞｪｸﾄから日付をarrayに格納して返却
  //  引数      : dateobj : date ｵﾌﾞｼﾞｪｸﾄ(Date)
  //  戻り値    : 日付格納配列(Array)
  // ===========================================================================
  function date_array_get (dateobj) {
    return new Array(dateobj.getFullYear(), dateobj.getMonth() + 1, dateobj.getDate(), dateobj.getDay());
  }
  // ===========================================================================
  //  関数名    : date_string_convert
  //  機能      : 8桁のdata stirngからDateｵﾌﾞｼﾞｪｸﾄに変換
  //  引数      : date_text : 8桁のString
  //  戻り値    : dateobj   : date ｵﾌﾞｼﾞｪｸﾄ(Date)
  // ===========================================================================
  function date_string_convert (date_text) {
    return new Date(date_text.substr(0, 4), zero_del(date_text.substr(4, 2)) - 1, date_text.substr(6, 2));
  }
  // ===========================================================================
  //  関数名    : date_week_text_get
  //  機能      : 曜日番号から曜日ﾃｷｽﾄに変換
  //  引数      : week_no : 曜日int
  //  戻り値    : 曜日String
  // ===========================================================================
  function date_week_text_get (week_no) {
    const wt = '日月火水木金土';
    return wt.substr(week_no, 1);
  }
  // ===========================================================================
  //  関数名    : get_add_date
  //  機能      : 日・月・年加算
  //  引数      : ret_date  : 対象日
  //            : days   : 加算日数
  //            : type   : year:年加算,month:月加算,day:日加算
  //  戻り値    : 日付
  // ===========================================================================
  function get_add_date (date, add, type) {
    const date_array = date_array_get(date);
    const year = date_array[0];
    const month = date_array[1];
    const day = date_array[2];
    let ret_date;
    add = pint(add);
    // 加算
    if (type == 'year') {
      ret_date = new Date(year + add, month - 1, day);
    } else if (type == "month") {
      ret_date = new Date(year, month + add - 1, day);
    } else {
      ret_date = new Date(year, month - 1, day + add);
    }
    return ret_date;
  }
  //------------------------------------------------------------------------------
  //  関数名    : yen
  //  機能      : int数値を円表記
  //  引数      : num         : 金額
  //            : yen_flg    :先頭に￥マークを付与
  //            : unit_flg    :末尾に円を付与
  //  戻り値    : text        : 円テキスト
  //------------------------------------------------------------------------------
  function yen (num, yen_flg, unit_flg) {
    let text = num;
    if(text === null || text === '') {
      text = '0';
    }
    text = String(text);
    text = text.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (yen_flg === true) {
      text = `¥${text}`;
    }
    if (unit_flg === true) {
      text = `${text}円`;
    }
    return text;
  }
  //------------------------------------------------------------------------------
  //  関数名    : download_start
  //  機能      : 印刷物用画面オープン
  //  引数      : address: 印刷物生成スクリプト相対アドレス
  //            : post_data: 印刷物生成スクリプト用データ（オプジェクト型）
  //            : window_name: 印刷物用画面名称（省略時はデフォルト名）
  //------------------------------------------------------------------------------
  function download_start (address, post_data) {
    let obj, form, input, body;

    if (!(post_data instanceof Object)) {
      post_data = new Object();
    }

    // POSTデータ(json)生成
    obj = JSON.stringify(post_data);

    form = document.createElement('form', '', '', '');
    form.action = `${DF.API_URL}`;
    form.method = 'POST';

    input = document.createElement('input', '', '', '');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', 'data');
    input.setAttribute('value', JSON.stringify({data:obj, module:address}));

    body = document.body;
    body.appendChild(form);
    form.appendChild(input);
    form.submit();
    body.removeChild(form);
  }
  // ===========================================================================
  // 外部へ
  // ===========================================================================
  this._$id = $id;
  this._pint = pint;
  this._emptyChk = emptyChk;
  this._zero_add = zero_add;
  this._zero_del = zero_del;
  this._date_text_get = date_text_get;
  this._date_array_get = date_array_get;
  this._date_string_convert = date_string_convert;
  this._date_week_text_get = date_week_text_get;
  this._get_add_date = get_add_date;
  this._yen = yen;
  this._download_start = download_start;

}

export default new lib();
